<template>
  <div
    class="auth-wrapper auth-v2"
    :dir="$functions.currentLangDirection()"
  >
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1" />
        <span class="brand-logo" />
      </b-link>

      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Reset Password"
          />
        </div>
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-4 p-lg-1 form-auth"
        :style="{ backgroundImage: `url(${backgroundUrl})` }"
        :class="{ mainbox: !isMobile, 'mainbox-tall': !isMobile && step === 2 }"
        style="background-size: cover;background-position: center;direction: rtl;"
      >
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="box2 px-xl-2 mx-auto"
          :style="step === 2 ? 'margin-top: -60px;' : 'margin-top: -140px;'"
          :dir="$functions.currentLangDirection()"
        >
          <!-- ==================== مرحله 1: شماره موبایل ==================== -->
          <template v-if="step === 1">
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
            >
              بازیابی رمز عبور
            </b-card-title>
            <b-card-text class="mb-2">
              شماره موبایل خود را وارد کنید تا کد تایید برایتان ارسال شود
            </b-card-text>

            <!-- Steps indicator -->
            <div class="steps-indicator">
              <div class="step-circle active">1</div>
              <div class="step-line-h" />
              <div class="step-circle">2</div>
            </div>

            <div class="auth-login-form mt-2">
              <b-form-group
                :label="$t('Mobile')"
                label-for="reset-mobile"
              >
                <vue-tel-input
                  v-model="mobile"
                  :only-countries="['ir', 'af', 'ae', 'iq', 'tj']"
                  default-country="IR"
                  @input="phone"
                  :placeholder="$t('Enter Mobile Number')"
                />
                <small class="text-danger">{{ mobileError }}</small>
              </b-form-group>

              <b-button
                variant="success"
                block
                :disabled="loading"
                @click="requestOtp"
              >
                <b-spinner
                  v-if="loading"
                  variant="outline-primary"
                  small
                />
                ارسال کد تایید
              </b-button>
            </div>

            <div class="back-section">
              <b-link
                :to="{name:'login-password'}"
                class="back-link"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"/></svg>
                بازگشت به صفحه ورود
              </b-link>
            </div>
          </template>

          <!-- ==================== مرحله 2: کد تایید + رمز جدید ==================== -->
          <template v-if="step === 2">
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
            >
              تنظیم رمز عبور
            </b-card-title>
            <b-card-text class="mb-2">
              کد تایید را وارد کنید و رمز عبور جدید تنظیم کنید
            </b-card-text>

            <!-- Steps indicator -->
            <div class="steps-indicator">
              <div class="step-circle done">&#10003;</div>
              <div class="step-line-h done" />
              <div class="step-circle active">2</div>
            </div>

            <div class="auth-login-form mt-2">
              <!-- نمایش شماره موبایل -->
              <div class="mobile-display-box">
                <span class="mobile-num" dir="ltr">{{ mobileFormatted }}</span>
                <a
                  class="change-mobile-link"
                  @click="goBackToStep1"
                >تغییر شماره</a>
              </div>

              <!-- کد تایید -->
              <b-form-group
                label="کد تایید پیامکی"
                label-for="otp-code"
              >
                <b-form-input
                  id="otp-code"
                  v-model="code"
                  class="otp-input"
                  maxlength="5"
                  autocomplete="off"
                  placeholder="_ _ _ _ _"
                  style="direction: ltr; text-align: center; letter-spacing: 12px; font-size: 24px;"
                  @keyup="codeChangeEn($event)"
                />
                <small class="text-danger">{{ codeError }}</small>
              </b-form-group>

              <!-- تایمر و ارسال مجدد -->
              <div class="timer-resend-row">
                <span class="timer-label">
                  ارسال مجدد تا
                  <span class="timer-count">{{ timerFormatted }}</span>
                </span>
                <b-button
                  size="sm"
                  :variant="timerCount <= 0 ? 'success' : 'secondary'"
                  :disabled="timerCount > 0"
                  @click="resendOtp"
                >
                  ارسال مجدد
                </b-button>
              </div>

              <!-- رمز عبور جدید -->
              <b-form-group
                label="رمز عبور جدید"
                label-for="new-password"
                class="mt-1"
              >
                <b-input-group>
                  <b-form-input
                    id="new-password"
                    v-model="newPassword"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="حداقل 6 کاراکتر"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                      @click="showPassword = !showPassword"
                      style="color: #333;"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-muted">حداقل 6 کاراکتر</small>
                <br>
                <small class="text-danger">{{ passwordError }}</small>
              </b-form-group>

              <!-- تکرار رمز عبور -->
              <b-form-group
                label="تکرار رمز عبور جدید"
                label-for="confirm-password"
              >
                <b-input-group>
                  <b-form-input
                    id="confirm-password"
                    v-model="confirmPassword"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="رمز عبور را مجددا وارد کنید"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                      @click="showPassword = !showPassword"
                      style="color: #333;"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ confirmError }}</small>
              </b-form-group>

              <b-button
                variant="success"
                block
                :disabled="loading"
                @click="submitReset"
              >
                <b-spinner
                  v-if="loading"
                  variant="outline-primary"
                  small
                />
                ثبت رمز عبور
              </b-button>
            </div>

            <div class="back-section">
              <a
                class="back-link"
                @click="goBackToStep1"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l1.41 1.41L7.83 11H20v2H7.83l5.58 5.59L12 20l-8-8z"/></svg>
                بازگشت به مرحله قبل
              </a>
            </div>
          </template>

          <!-- ==================== مرحله 3: موفقیت ==================== -->
          <template v-if="step === 3">
            <div style="text-align: center; padding-top: 40px;">
              <div class="success-icon-circle">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="#fff"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              </div>
              <b-card-title
                title-tag="h2"
                class="font-weight-bold mb-1 mt-2"
              >
                رمز عبور تنظیم شد
              </b-card-title>
              <b-card-text class="mb-2">
                رمز عبور شما با موفقیت تنظیم شد.<br>
                اکنون می‌توانید با شماره موبایل و رمز عبور وارد شوید.
              </b-card-text>
              <b-button
                variant="success"
                block
                class="mt-2"
                :to="{name:'login-password'}"
              >
                ورود به حساب
              </b-button>
            </div>
          </template>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BButton, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import { VueTelInput } from 'vue-tel-input'
import { functions } from '@/functions'

Vue.prototype.$functions = functions

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BButton,
    BSpinner,
    VueTelInput,
  },
  data() {
    return {
      step: 1,
      mobile: '',
      mobileFormatted: '',
      code: '',
      newPassword: '',
      confirmPassword: '',
      resetToken: '',
      mobileError: '',
      codeError: '',
      passwordError: '',
      confirmError: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      loading: false,
      isMobile: Vue.prototype.$functions.isMobile(),
      timerCount: 120,
      timerEnabled: false,
      timerInterval: null,
      showPassword: false,
    }
  },
  computed: {
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
    timerFormatted() {
      const min = Math.floor(this.timerCount / 60).toString().padStart(2, '0')
      const sec = (this.timerCount % 60).toString().padStart(2, '0')
      return `${min}:${sec}`
    },
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app
    return { appName, appLogoImage }
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    if (formGroup[0]) formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
  },
  beforeDestroy() {
    if (this.timerInterval) clearInterval(this.timerInterval)
  },
  methods: {
    phone(number, phoneObject) {
      if (phoneObject.isValid) {
        this.mobileFormatted = `0${phoneObject.number.significant}`
        this.mobileError = ''
      }
    },
    codeChangeEn(event) {
      this.code = this.$functions.fixNumbers(event.target.value)
    },
    startTimer() {
      this.timerCount = 120
      this.timerEnabled = true
      if (this.timerInterval) clearInterval(this.timerInterval)
      this.timerInterval = setInterval(() => {
        this.timerCount--
        if (this.timerCount <= 0) {
          clearInterval(this.timerInterval)
          this.timerEnabled = false
        }
      }, 1000)
    },
    goBackToStep1() {
      this.step = 1
      this.code = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.codeError = ''
      this.passwordError = ''
      this.confirmError = ''
      if (this.timerInterval) clearInterval(this.timerInterval)
    },
    requestOtp() {
      this.mobileError = ''
      if (!this.mobileFormatted || this.mobileFormatted.length !== 11) {
        this.mobileError = 'شماره موبایل نامعتبر است'
        return
      }

      this.loading = true
      this.$store.dispatch('auth/resetPasswordRequest', {
        mobile: this.mobileFormatted,
      }).then(
        () => {
          this.loading = false
          this.step = 2
          this.startTimer()
        },
        error => {
          this.loading = false
          const msg = (error.response && error.response.data)
            || error.message
            || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: msg,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    resendOtp() {
      if (this.timerCount > 0) return
      this.loading = true
      this.$store.dispatch('auth/resetPasswordRequest', {
        mobile: this.mobileFormatted,
      }).then(
        () => {
          this.loading = false
          this.startTimer()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'کد ارسال شد',
              text: 'کد تایید مجددا ارسال شد',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        },
        error => {
          this.loading = false
          const msg = (error.response && error.response.data)
            || error.message
            || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: msg,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    submitReset() {
      this.codeError = ''
      this.passwordError = ''
      this.confirmError = ''

      let hasError = false
      if (!this.code || this.code.length !== 5) {
        this.codeError = 'کد تایید باید 5 رقم باشد'
        hasError = true
      }
      if (!this.newPassword || this.newPassword.length < 6) {
        this.passwordError = 'رمز عبور باید حداقل 6 کاراکتر باشد'
        hasError = true
      }
      if (this.newPassword !== this.confirmPassword) {
        this.confirmError = 'رمز عبور و تکرار آن مطابقت ندارند'
        hasError = true
      }
      if (hasError) return

      this.loading = true
      // مرحله 1: تایید OTP
      this.$store.dispatch('auth/resetPasswordVerify', {
        mobile: this.mobileFormatted,
        code: this.code,
      }).then(
        res => {
          this.resetToken = res.result.resetToken
          // مرحله 2: ثبت رمز عبور
          this.$store.dispatch('auth/resetPasswordSet', {
            mobile: this.mobileFormatted,
            resetToken: this.resetToken,
            password: this.newPassword,
          }).then(
            () => {
              this.loading = false
              this.step = 3
            },
            error => {
              this.loading = false
              const msg = (error.response && error.response.data)
                || error.message
                || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: msg,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
          )
        },
        error => {
          this.loading = false
          const msg = (error.response && error.response.data)
            || error.message
            || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: msg,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{ width: 70px; }
.auth-wrapper .auth-bg{ background-color: #232633; color: #fff; }
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{ color: #fff !important; }
[dir=rtl] .vue-tel-input{ direction: ltr; }
.vti__dropdown-item{ color: #000; }
.vti__dropdown-item strong{ font-weight: 400; }
.vue-tel-input{ background: #fff; padding: 3px; }
.auth-wrapper label, .auth-wrapper span, .auth-wrapper h2, .auth-wrapper .brand-text{ color: #eee !important; }

.mainbox{
  background: #344935d6 !important;
  position: absolute;top: 10%;margin-left: auto;margin-right: auto;left: 0;right: 0;width: 400px;height: 500px;border-radius: 2%;
}
.mainbox-tall{
  height: auto !important; min-height: 620px; top: 3% !important;
}
.mainbox .box2{ margin-top: -40px !important; }

/* Steps indicator */
.steps-indicator {
  display: flex; justify-content: center; align-items: center; gap: 8px; margin-bottom: 20px;
}
.step-circle {
  width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center;
  justify-content: center; font-size: 13px; background: #555; color: #aaa;
}
.step-circle.active { background: #28a745; color: #fff; }
.step-circle.done { background: #1a7a31; color: #fff; }
.step-line-h { width: 40px; height: 2px; background: #555; }
.step-line-h.done { background: #28a745; }

/* Mobile display */
.mobile-display-box {
  display: flex; align-items: center; justify-content: space-between;
  background: #2a3a2a; border-radius: 6px; padding: 12px 14px;
  margin-bottom: 15px;
}
.mobile-num { font-size: 17px; letter-spacing: 1px; color: #fff; }
.change-mobile-link {
  color: #8fc !important; font-size: 12px; cursor: pointer;
  border-bottom: 1px dashed #8fc; padding-bottom: 1px;
}
.change-mobile-link:hover { color: #bff !important; border-color: #bff; }

/* Timer row */
.timer-resend-row {
  display: flex; justify-content: space-between; align-items: center;
  margin-top: 8px; margin-bottom: 5px;
}
.timer-label { color: #ccc; font-size: 13px; }
.timer-count { color: #ffa; font-weight: bold; font-size: 15px; margin: 0 4px; }

/* Back section */
.back-section {
  text-align: center; margin-top: 18px; padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.1);
}
.back-link {
  color: #ccc !important; font-size: 13px; cursor: pointer; text-decoration: none !important;
  display: inline-flex; align-items: center; gap: 5px;
}
.back-link:hover { color: #fff !important; }

/* Success icon */
.success-icon-circle {
  width: 70px; height: 70px; background: #28a745; border-radius: 50%;
  margin: 0 auto 15px; display: flex; align-items: center; justify-content: center;
}
</style>
